import { render } from "./indexpartners.vue?vue&type=template&id=2b795526"
import script from "./indexpartners.vue?vue&type=script&lang=js"
export * from "./indexpartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__